import React from "react";
import NumberFormat from "react-number-format";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import {IDaNumberFormatFieldProps} from "./types";

export const DaNumberFormatField: React.FC<IDaNumberFormatFieldProps<any>> = (
    {
        control,
        name,
        label,
        defaultValue = "",
        readOnly = false,
        required = false,
        size = "medium",
        variant = "standard",
        errors,
        numberFormat = undefined,
    } : IDaNumberFormatFieldProps<any>

) => {

  return (
      <Controller
          name={name}
          control={control}
          render={({ field }) =>
            <NumberFormat
                {...field}
                format={numberFormat}
                label={required ? `${label} *` : label}
                variant={variant}
                size={size}
                error={!!errors[name]}
                helperText={errors[name]?.message ?? ''}
                fullWidth
                customInput={TextField}
                InputProps={readOnly ? {
                    readOnly: true,
                    className: 'Mui-disabled'} : {}
                }
              />
          }
        />
  );
};